import type { SVGProps } from 'react'

// Solid X-in-circle — filled disc with an X cutout. Used for the "Deny
// request" row in MoreActionsDrawer. Matches Figma's `x-circle-solid`
// glyph (component node `179:12449`) referenced from node `1448:38836`.
//
// Implemented as a single `fillRule="evenodd"` path so the X cutout
// shows whatever's behind the icon (no hardcoded white fill). The
// `currentColor` paint inherits from the surrounding text/icon color
// — for the destructive Deny row this resolves to the error-primary
// text token via `ListItem.module.scss`'s `.destructive .leading`
// selector.

export default function XCircle(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-2.293-13.707a1 1 0 0 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12l2.293-2.293a1 1 0 0 0-1.414-1.414L12 10.586 9.707 8.293Z"
      />
    </svg>
  )
}
